import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from "@cbex/utils/theme";
import { Stack } from "@mui/material";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import { CustomTypographyComponent } from "@cbex/ui/text";

export const Header = () => {
  const theme = useTheme();
  //@ts-ignore
  const pathName = usePathname();
  const t = useTranslations();
  return (
    <Stack direction={"row"} width={"100%"}>
      <Stack
        sx={{
          height: theme.dimensions.heightAppBar,
          backgroundColor: theme.appPalette.tertiary[99],
          // justifyContent: "center",
        }}
        width={"100%"}
      >
        <Toolbar>
          <Stack width={"100%"} paddingLeft={1}>
            <CustomTypographyComponent
              variant="h5"
              color={theme.appColors.primary}
              noWrap
              component="div"
              fontWeight={600}
              sx={{ display: { xs: "none", sm: "block" } }}
            >
              {pathName === "/"
                ? t("common.home")
                : t(`common.${pathName.split("/")[1]}`)}
              {/* {TENANT_ENV !== "PROD" ? `-- ${TENANT_ENV} --` : ""} */}
            </CustomTypographyComponent>
          </Stack>
        </Toolbar>
      </Stack>
    </Stack>
  );
};
